import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PurchaseInvoiceComponent } from './purchase-invoice.component';
import { AddEntryPurchaseInvoiceComponent } from './add-entry-purchase-invoice/add-entry-purchase-invoice.component';


const routes: Routes = [

	{
		path: 'purchase', component: PurchaseInvoiceComponent
	}, 
	{
		path: 'purchase/save', component: AddEntryPurchaseInvoiceComponent
	},
	{
		path: 'purchase/view/:invoice', component: AddEntryPurchaseInvoiceComponent
	},
	{
		path: 'purchase/save/:transaction_type', component: AddEntryPurchaseInvoiceComponent
	},
	{
		path: 'purchase/save/:transaction_type/:invoice', component: AddEntryPurchaseInvoiceComponent
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class PurchaseInvoiceRoutingModule { }
